'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  margin-left: 6px;\n'], ['\n  position: relative;\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  margin-left: 6px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 997;\n    backface-visibility: hidden;\n    transition: all 0.5s;\n    overflow-y: auto;\n\n    .ql-container {\n        max-height: 50vh;\n        overflow-y: auto;\n    }\n'], ['\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 997;\n    backface-visibility: hidden;\n    transition: all 0.5s;\n    overflow-y: auto;\n\n    .ql-container {\n        max-height: 50vh;\n        overflow-y: auto;\n    }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: calc(-100% - 16px);\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 8px;\n  background-color: #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  border-radius: 4px;\n  z-index: 9999;\n  width: auto;\n\n  &:after {\n    content: "";\n    position: absolute;\n    height: 8px;\n    width: 8px;\n    z-index: 1000;\n    top: calc(100% - 4px);\n    left: calc(50% - 4px);\n    box-shadow: -1px 1px 2px -1px rgba(0,0,0,0.15);\n    background-color: ', ';\n    transform: rotate(-45deg);\n  }\n'], ['\n  position: absolute;\n  top: calc(-100% - 16px);\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 8px;\n  background-color: #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  border-radius: 4px;\n  z-index: 9999;\n  width: auto;\n\n  &:after {\n    content: "";\n    position: absolute;\n    height: 8px;\n    width: 8px;\n    z-index: 1000;\n    top: calc(100% - 4px);\n    left: calc(50% - 4px);\n    box-shadow: -1px 1px 2px -1px rgba(0,0,0,0.15);\n    background-color: ', ';\n    transform: rotate(-45deg);\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    font-family: Poppins, sans-serif;\n    color: ', ';\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    text-align: left;\n    ', '\n'], ['\n    font-family: Poppins, sans-serif;\n    color: ', ';\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    text-align: left;\n    ', '\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    cursor: ', ';\n    margin-right: 4px;    fill: ', ';\n\n  &:hover {\n    fill: ', ';\n    }\n'], ['\n    cursor: ', ';\n    margin-right: 4px;\\\n    fill: ', ';\n\n  &:hover {\n    fill: ', ';\n    }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactQuill = require('react-quill');

var _reactQuill2 = _interopRequireDefault(_reactQuill);

require('react-quill/dist/quill.snow.css');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactIntl = require('react-intl');

var _colors = require('../../constants/colors');

var _sizes = require('../../constants/sizes');

var _overlay = require('../../atoms/overlay');

var _overlay2 = _interopRequireDefault(_overlay);

var _modal = require('../modal');

var _modal2 = _interopRequireDefault(_modal);

var _header = require('../../atoms/text/header');

var _header2 = _interopRequireDefault(_header);

var _reselect = require('reselect');

var _selectSession = require('../../selectors/context/selectSession');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TooltipContainer = _styledComponents2.default.div(_templateObject);

var Wrapper = _styledComponents2.default.div(_templateObject2);

var NonAdminTooltip = _styledComponents2.default.div(_templateObject3, _colors.Colors.LightMode);

var TooltipText = _styledComponents2.default.div(_templateObject4, _colors.Colors.claimBlack, function (_ref) {
    var viewMode = _ref.viewMode;
    return !viewMode ? 'white-space: nowrap;' : null;
});

var Icon = _styledComponents2.default.span(_templateObject5, function (_ref2) {
    var clickable = _ref2.clickable;
    return clickable ? 'pointer' : 'default';
}, function (_ref3) {
    var isEmpty = _ref3.isEmpty;
    return isEmpty ? _colors.Colors.StrokeVeryLight : _colors.Colors.StrokeVeryDark;
}, _colors.Colors.Primary);

var modules = {
    toolbar: [["bold", "italic", "underline", "strike"], [{ align: ["right", "center", "justify"] }], [{ list: "ordered" }, { list: "bullet" }], [{ color: ["red", "#785412"] }]]
};

var formats = ["bold", "italic", "underline", "strike", "list", "bullet", "color", "align"];

var ToolTip2 = function ToolTip2(_ref4) {
    var header = _ref4.header,
        text = _ref4.text,
        saveHandler = _ref4.saveHandler,
        reduceHandler = _ref4.reduceHandler,
        _ref4$maxLength = _ref4.maxLength,
        maxLength = _ref4$maxLength === undefined ? 50 : _ref4$maxLength,
        session = _ref4.session,
        intl = _ref4.intl;

    var _useState = (0, _react.useState)(text),
        _useState2 = _slicedToArray(_useState, 2),
        value = _useState2[0],
        setValue = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = _slicedToArray(_useState3, 2),
        showTooltip = _useState4[0],
        setShowTooltip = _useState4[1];

    var _useState5 = (0, _react.useState)(false),
        _useState6 = _slicedToArray(_useState5, 2),
        viewMode = _useState6[0],
        setViewMode = _useState6[1];

    var _useState7 = (0, _react.useState)(false),
        _useState8 = _slicedToArray(_useState7, 2),
        editMode = _useState8[0],
        setEditMode = _useState8[1];

    var isAdmin = session !== undefined && session.userType && session.userType === 'administrator';
    var isEmpty = !text || text === '';

    var placeholderText = intl.formatMessage({ id: 'Tooltip2.placeholder' });
    var saveText = intl.formatMessage({ id: 'Tooltip2.save' });
    var cancelText = intl.formatMessage({ id: 'Tooltip2.cancel' });

    var handleMouseEnter = (0, _react.useCallback)(function () {
        if (!isEmpty) {
            setShowTooltip(true);
        }
    }, [isEmpty]);

    var handleMouseLeave = (0, _react.useCallback)(function () {
        setShowTooltip(false);
    }, []);

    var iconClickHandler = (0, _react.useCallback)(function () {
        if (isAdmin) {
            setShowTooltip(false);
            setValue(text);
            setEditMode(true);
        }

        if (!isAdmin && strippedText(text).length > maxLength) {
            setShowTooltip(false);
            setViewMode(true);
        }
    }, [text]);

    var handleViewerCancel = (0, _react.useCallback)(function () {
        setShowTooltip(false);
        setViewMode(false);
        setEditMode(false);
    }, []);

    var handleEditorCancel = (0, _react.useCallback)(function () {
        if (editMode) {
            setEditMode(false);
            reduceHandler()(value);
        } else {
            setViewMode(false);
        }
    }, [editMode, value]);

    var handleEditorChange = (0, _react.useCallback)(function (value) {
        return strippedText(value).length ? reduceHandler()(value) : reduceHandler()('');
    }, []);

    var handleEditorSave = (0, _react.useCallback)(function () {
        saveHandler();
        setEditMode(false);
        setShowTooltip(false);
    }, []);

    var strippedText = (0, _react.useCallback)(function (text) {
        var div = document.createElement('div');
        div.innerHTML = text;

        return div.textContent || div.innerText || '';
    }, []);

    var stripHTMLAndLimitLength = (0, _react.useCallback)(function (text) {
        var st = strippedText(text);

        if (st.length > maxLength) {
            return st.substring(0, maxLength) + ' ...';
        }

        return st;
    }, []);

    var tooltipPopup = (0, _react.useMemo)(function () {
        return _react2.default.createElement(
            NonAdminTooltip,
            null,
            _react2.default.createElement(
                TooltipText,
                { viewMode: viewMode },
                stripHTMLAndLimitLength(text)
            )
        );
    }, [text]);

    var nonEditableModal = (0, _react.useMemo)(function () {
        return _react2.default.createElement(
            Wrapper,
            null,
            _react2.default.createElement(_overlay2.default, { visible: viewMode, clickEvent: handleViewerCancel }),
            _react2.default.createElement(_modal2.default, {
                size: _sizes.Sizes.md,
                visible: viewMode,
                items: _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    _react2.default.createElement(_header2.default, { size: _sizes.Sizes.md, text: header, bottom: _sizes.Sizes.md }),
                    _react2.default.createElement(TooltipText, { className: 'ql-container', viewMode: viewMode, dangerouslySetInnerHTML: { __html: text } })
                ),
                closeEvent: handleViewerCancel,
                actionButtons: []
            })
        );
    }, [viewMode, text]);

    var editableModal = (0, _react.useMemo)(function () {
        return _react2.default.createElement(
            Wrapper,
            null,
            _react2.default.createElement(_overlay2.default, { visible: editMode, clickEvent: handleEditorCancel }),
            _react2.default.createElement(_modal2.default, {
                size: _sizes.Sizes.md,
                visible: editMode,
                items: _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    _react2.default.createElement(_header2.default, { size: _sizes.Sizes.md, text: header, bottom: _sizes.Sizes.md }),
                    _react2.default.createElement(_reactQuill2.default, {
                        theme: 'snow',
                        modules: modules,
                        formats: formats,
                        defaultValue: text,
                        onChange: handleEditorChange,
                        placeholder: placeholderText
                    })
                ),
                closeEvent: handleEditorCancel,
                actionButtons: [{
                    primary: true,
                    text: saveText,
                    clickEvent: handleEditorSave
                }, {
                    text: cancelText,
                    clickEvent: handleEditorCancel
                }]
            })
        );
    }, [editMode, text, placeholderText, saveText, cancelText]);

    if (!isEmpty || isAdmin) {
        return _react2.default.createElement(
            TooltipContainer,
            {
                onMouseEnter: handleMouseEnter,
                onMouseLeave: handleMouseLeave
            },

            // case for non admins and truncated text
            showTooltip ? tooltipPopup : viewMode ? nonEditableModal : editMode ? editableModal : null,
            _react2.default.createElement(
                Icon,
                {
                    onClick: iconClickHandler,
                    isEmpty: isEmpty,
                    clickable: isAdmin || !isAdmin && strippedText(text).length > maxLength
                },
                _react2.default.createElement(
                    'svg',
                    { xmlns: 'http://www.w3.org/2000/svg', width: '24', height: '24', viewBox: '0 0 24 24' },
                    _react2.default.createElement(
                        'g',
                        { transform: 'translate(24 24) rotate(180)' },
                        _react2.default.createElement('rect', { width: '24', height: '24', fill: 'transparent' }),
                        _react2.default.createElement('path', { d: 'M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20ZM10,2a8,8,0,1,0,8,8A8.009,8.009,0,0,0,10,2Zm.5,12h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,10.5,14ZM9.468,10a.25.25,0,0,1-.248-.22l-.4-3.22a.5.5,0,0,1,.5-.56H10.68a.5.5,0,0,1,.5.56l-.4,3.22a.25.25,0,0,1-.248.22H9.468Z', transform: 'translate(2 2)' })
                    )
                )
            )
        );
    } else {
        return null;
    }
};

var mapStateToProps = (0, _reselect.createStructuredSelector)({
    session: (0, _selectSession.selectSession)()
});

var ToolTip2WithIntl = (0, _reactIntl.injectIntl)(ToolTip2);
exports.default = (0, _reactRedux.connect)(mapStateToProps)(ToolTip2WithIntl);